(() => {
  const mount = (form) => {
    if (form.dataset.predictiveReady) return;
    form.dataset.predictiveReady = 'true';
    const input = form.querySelector('input[name="q"]');
    if (!input || form.closest('predictive-search-component')) return;
    let panel = form.querySelector('[data-mh-suggestions]');
    if(!panel){panel=document.createElement('div');panel.className='mh-pro-suggestions';panel.dataset.mhSuggestions='';panel.hidden=true;form.append(panel);form.classList.add('mh-unified-search');}
    panel.id ||= `mh-results-${input.id || Math.random().toString(36).slice(2)}`;
    panel.setAttribute('aria-live','polite');input.setAttribute('aria-controls',panel.id);input.setAttribute('aria-autocomplete','list');input.autocomplete='off';
    const searchRoot = window.Shopify?.routes?.root || '/';
    let timer;
    let request;
    let currentQuery = '';

    const close = () => {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };
    const open = () => {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };
    const node = (tag, className, value) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (value != null) element.textContent = value;
      return element;
    };
    const safeProductUrl = (value) => {
      try {
        const url = new URL(value, location.origin);
        return url.origin === location.origin && url.pathname.includes('/products/') ? url.href : null;
      } catch { return null; }
    };
    const render = (products, query) => {
      panel.replaceChildren();
      const head = node('div', 'mh-pro-suggestions__head');
      head.append(node('span', '', 'Productos'), node('span', '', `${products.length} ${products.length === 1 ? 'resultado' : 'resultados'}`));
      panel.append(head);
      if (!products.length) {
        import('./mhesus-search-index.js?v=ux15b').then(module=>{if(currentQuery===query)module.renderSearchHelp(panel,query);}).catch(()=>{});
      }
      products.forEach((product) => {
        const href = safeProductUrl(product.url);
        if (!href) return;
        const item = node('a', 'mh-pro-suggestions__item');
        item.href = href;
        const media = node('span', 'mh-pro-suggestions__image');
        const imageUrl = product.featured_image?.url || product.image;
        if (imageUrl) {
          const image = node('img');
          image.src = imageUrl;
          image.alt = '';
          image.loading = 'lazy';
          media.append(image);
        }
        const copy = node('span', 'mh-pro-suggestions__copy');
        copy.append(node('strong', '', product.title), node('small', '', [product.vendor || 'Repuesto', product.sku ? `CÓD. ${product.sku}` : ''].filter(Boolean).join(' · ')));
        const price = Number(product.price);
        const priceText = Number.isFinite(price) && price > 0 ? new Intl.NumberFormat('es-PE', {style:'currency', currency:'PEN'}).format(price) : 'Precio por confirmar';
        item.append(media, copy, node('span', 'mh-pro-suggestions__price', priceText));
        panel.append(item);
      });
      const all = node('a', 'mh-pro-suggestions__all');
      const url = new URL(form.action);
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');
      all.href = url.href;
      all.append(node('span', '', 'Ver todos los resultados'), node('span', '', '↗'));
      panel.append(all);
      open();
      import('./mhesus-search-index.js?v=ux15b').then(module=>module.revealResults(panel)).catch(()=>{});
    };
    const search = async (query) => {
      try {
        const module=await import('./mhesus-search-index.js?v=ux15b');
        const products=await module.prefixProducts(query);
        if (input.value.trim() !== query || currentQuery !== query) return;
        render(products,query);
      } catch {
        if(input.value.trim() !== query)return;
        panel.replaceChildren(node('p','mh-pro-suggestions__empty','No pudimos cargar el catálogo. Intenta nuevamente.'));open();
      }
    };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      currentQuery = input.value.trim();
      request?.abort();
      close();
      if (!currentQuery.length) return;
      timer = setTimeout(() => search(currentQuery), 40);
    });
    input.addEventListener('focus',()=>{import('./mhesus-search-index.js?v=ux15b').then(module=>module.loadCatalog()).catch(()=>{});});
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowDown' && !panel.hidden) {
        const first = panel.querySelector('a');
        if (first) { event.preventDefault(); first.focus(); }
      }
    });
    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { close(); input.focus(); }
    });
    document.addEventListener('pointerdown', (event) => {
      if (!form.contains(event.target)) close();
    });
    form.addEventListener('submit', () => { clearTimeout(timer); request?.abort(); });
  };
  const init = () => document.querySelectorAll('[data-mh-predictive],form[role="search"]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

